import { computed, ref } from 'vue'
import { defineStore, getActivePinia } from 'pinia'
import { TOKEN_KEY, clearLocalAuthStorage } from '@/api/auth-storage'
import { doLogout } from '@/api/auth'
import { useMenuStore } from '@/stores/menu'
import { useCaseWorkCountStore } from '@/stores/caseWorkCount'
import { useMessageNoticeStore } from '@/stores/messageNotice'
import { usePermissionStore } from '@/stores/permission'
import { useUserProfileStore } from '@/stores/userProfile'
import { secureLocalStorage } from '@/utils/secureLocalStorage'
import { clearPasswordExpireRemindSession } from '@/utils/passwordExpire'

function getToken() {
  return secureLocalStorage.getItem(TOKEN_KEY)
}

export const useAuthStore = defineStore('auth', () => {
  const tokenRef = ref<string | null>(getToken())

  const token = computed(() => tokenRef.value ?? getToken())

  const isLoggedIn = computed(() => Boolean(token.value))

  function login(accessToken: string) {
    secureLocalStorage.setItem(TOKEN_KEY, accessToken)
    tokenRef.value = accessToken
  }

  async function logout() {
    try {
      await doLogout()
    } catch {
      // 接口失败仍清理本地登录态
    } finally {
      clearSessionLocal()
    }
  }

  /** 仅清理本地 token / 用户信息（不请求退出接口；供会话过期等场景复用） */
  function clearSessionLocal() {
    clearLocalAuthStorage()
    clearPasswordExpireRemindSession()
    tokenRef.value = null
    const pinia = getActivePinia()
    if (pinia) {
      useMenuStore(pinia).reset()
      usePermissionStore(pinia).reset()
      useUserProfileStore(pinia).clear()
      useMessageNoticeStore(pinia).clear()
      useCaseWorkCountStore(pinia).clear()
    }
  }

  return { token, isLoggedIn, login, logout, clearSessionLocal }
})
